import AnaliseSeoTextual from '@pages/DicasOtimizacao/Componentes/AnaliseSeoTextual';
import { OptiTabs } from '@componentsNew/OptiTabs';
import { useEffect, useState } from '@wordpress/element';
import { CardSeo } from './CardSeo';
import { CardSeoItem } from './CardSeoItem';
import { useAnalisesPost } from '@hooks/Analises/useAnalisesPost';
import { useIntegracao } from '@pages/ArtigoIA/Context/IntegracaoContext';

export function TabsSeoArtigo() {
  const [selecionado, setSelecionado] = useState('criterios');

  const { realizarAnaliseSeo, setRealizarAnaliseSeo } = useIntegracao();

  const {
    gerarNovaAnalise: gerarNovaAnaliseSeoTextual,
    analise: analiseSeoTextual,
    carregando: carregandoSeoTextual,
    erro: erroSeoTextual,
  } = useAnalisesPost({
    tipo: 'textual_ia',
    idPost: localStorage.getItem('id_artigo_ia') ?? 0
  });

  useEffect(() => {
    if (!realizarAnaliseSeo) return;
    gerarNovaAnaliseSeoTextual().then(() => setRealizarAnaliseSeo(false));
  }, [realizarAnaliseSeo]);

  const data = [
    {
      label: 'Critérios',
      value: 'criterios',
      content: (
        <CardSeo
          children={
            <CardSeoItem
              erro={erroSeoTextual}
              carregando={carregandoSeoTextual}
              children={<AnaliseSeoTextual analise={analiseSeoTextual} />}
            />
          }
        />
      ),
    },
  ];

  return <OptiTabs selecionado={selecionado} setSelecionado={setSelecionado} data={data} />;
}
